<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="mb-0">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar Tipo de Turno</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert
            v-if="esPorDefecto"
            class="mt-4"
            color="purple"
            dark
            outlined
            dismissible
          >
            Está editando el único Tipo de Turno, por lo cual no podrá cambiar
            el tipo de turno por defecto.
          </v-alert>
          <v-row dense class="mt-3">
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="nombreTipoTurno"
                prepend-icon="mdi-account"
                label="Nombre Tipo de Turno *"
                maxlength="80"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="9" sm="4" md="2">
              <v-text-field
                v-model="sigla"
                prepend-icon="mdi-account"
                label="Sigla"
                maxlength="3"
                dense
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" md="6" class="tipo-turno-checkboxes">
              <v-checkbox
                class="ml-4 mt-2"
                v-model="porDefecto"
                label="Es tipo de turno por defecto"
                color="primary"
                :disabled="esPorDefecto"
                hide-details
              ></v-checkbox>
              <v-checkbox
                class="ml-4 mt-2"
                v-model="esTurnoFijo"
                label="Es Turno Fijo"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <v-select
                :items="intervalos"
                prepend-icon="mdi-calendar-multiple"
                v-model="duracion"
                label="Duración Turno (Para Turnos Web)"
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" md="3" sm="4">
              <v-checkbox
                class="ml-4 mt-2"
                v-model="requiereProfesor"
                label="Requiere profesor en turno"
                color="primary"
                hide-details
              ></v-checkbox
            ></v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                :label="disponibleWeb ? 'Valor a cobrar online' : 'Valor por jugador'"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Configuración exclusiva del tipo de turno web -->
          <template v-if="disponibleWeb">
            <v-divider class="my-2"></v-divider>
            <v-alert color="primary" dark outlined dense class="mb-2">
              Este es el Tipo de Turno Web de la institución. El "Valor a cobrar
              online" es lo que abona el jugador al reservar.
            </v-alert>
            <v-row class="mt-2">
              <v-col cols="12" md="4" sm="6">
                <v-checkbox
                  class="ml-4 mt-2"
                  v-model="esSenia"
                  label="El valor cobrado es una seña"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="6" sm="6" v-if="esSenia">
                <v-text-field
                  v-model="precioFinal"
                  prepend-icon="mdi-currency-usd"
                  label="Valor total del turno (opcional, informativo)"
                  :rules="precioFinalRules"
                  @blur="toFixedPrecioFinal"
                  @keypress="onlyNumber"
                  dense
                  maxlength="10"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarTipoTurno"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    nombreTipoTurno: null,
    porDefecto: false,
    disponibleWeb: false,
    requiereProfesor: false,
    esTurnoFijo: false,
    esSenia: false,
    precioFinal: null,
    sigla: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    precioFinalRules: [
      // El valor total del turno es opcional; si se ingresa, debe ser mayor a la sena (total).
      (v) =>
        v === null ||
        v === undefined ||
        v === "" ||
        parseFloat(v) > parseFloat(vm.total || 0) ||
        "El valor total debe ser mayor a la seña",
    ],
    duracion: 1,
    intervalos: [1, 2, 3, 4, 5, 6],
    total: null,
  }),

  props: {
    visible: {
      type: Boolean,
    },
    esPorDefecto: {
      type: Boolean,
    },
    idTipoTurno: {
      type: Number,
    },
  },

  computed: {
    show: {
      get() {
        this.porDefecto = this.esPorDefecto;
        if (this.visible) this.buscarDatosTipoTurno();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    toFixedPrecioFinal() {
      if (isNaN(parseFloat(this.precioFinal)))
        this.precioFinal = parseFloat(0.0).toFixed(2);
      else this.precioFinal = parseFloat(this.precioFinal).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    buscarDatosTipoTurno() {
      let self = this;

      axios
        .get("/Profesional/BuscarDatosTipoTurno?", {
          params: {
            idTipoTurno: this.idTipoTurno,
          },
        })
        .then((response) => {
          self.nombreTipoTurno = response.data.nombreTipoTurno;
          self.porDefecto = response.data.porDefecto;
          self.sigla = response.data.sigla;
          self.disponibleWeb = response.data.disponibleWeb;
          self.duracion = response.data.duracion;
          self.requiereProfesor = response.data.requiereProfesor;
          self.total = response.data.total;
          self.esTurnoFijo = response.data.esTurnoFijo;
          self.esSenia = response.data.esSenia || false;
          self.precioFinal = response.data.precioFinal;
        })
        .catch((error) => {});
    },
    modificarTipoTurno() {
      // Validacion: cuando es sena y se ingresa un valor total, este debe ser mayor a la sena cobrada online.
      const tienePrecioFinal =
        this.precioFinal !== null &&
        this.precioFinal !== undefined &&
        this.precioFinal !== "";
      if (
        this.disponibleWeb &&
        this.esSenia &&
        tienePrecioFinal &&
        parseFloat(this.precioFinal) <= parseFloat(this.total || 0)
      ) {
        this.showAlert({
          icon: "warning",
          title:
            "El valor total del turno debe ser mayor a la seña cobrada online.",
          vm: this,
          timer: 2500,
        });
        return;
      }

      this.$swal({
        title: "Modificar Tipo de Turno",
        text: "¿Desea modificar el tipo de turno?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosTipoTurno = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idTipoTurno: this.idTipoTurno,
            nombreTipoTurno: this.nombreTipoTurno,
            porDefecto: this.porDefecto,
            sigla: this.sigla,
            // El backend preserva el flag real; se envía el valor actual del registro.
            disponibleWeb: this.disponibleWeb,
            duracion: this.duracion,
            requiereProfesor: this.requiereProfesor,
            total: this.total,
            esTurnoFijo: this.esTurnoFijo,
            // Seña y precio final solo aplican al tipo de turno web.
            esSenia: this.disponibleWeb ? this.esSenia : false,
            precioFinal:
              this.disponibleWeb && this.esSenia && tienePrecioFinal
                ? this.precioFinal
                : null,
          };
          let self = this;
          axios
            .post("/Profesional/ModificarTipoTurno", datosTipoTurno)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "warning",
                  title:
                    "Ya existe un tipo de turno registrado con ese nombre.",
                  vm: self,
                  timer: 2000,
                });
              } else {
                self.$refs.form.resetValidation();

                document.getElementsByClassName(
                  "v-dialog--active",
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Tipo de Turno modificado exitosamente.",
                  vm: self,
                  timer: 2000,
                });
                self.$emit("tipoTurnoModificado");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "warning",
                title: "El Tipo de Turno no pudo ser modificado.",
                vm: this,
                timer: 2000,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
  },
};
</script>
<style scoped lang="scss">
.tipo-turno-checkboxes {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>
